<template>
  <table style="max-width: 200px" class="border-b-0" cellpadding="0" cellspacing="0">
    <thead>
      <tr class="px-0 py-0 bg-gray-100">
        <td colspan="3" class="border-1 px-0 py-0">Acomptes et payments</td>
      </tr>
      <tr class="px-0 py-0 bg-gray-50">
        <td class="border-1 border-gray-900">Date</td>
        <td class="border-1 border-gray-900">Montant</td>
        <td class="print-hidden border-1 border-gray-900">&nbsp;</td>
      </tr>
    </thead>
    <tbody>
      <tr class="item border-b-0" v-for="p in payments" :key="p.id">
        <td class="border-1 border-black">{{ isoDatePart(p.date) }}</td>
        <td class="border-1 border-black">&euro;&nbsp;{{ p.amount }} ({{ PAYMENT_METHODS[p.method] }})</td>
        <td class="print-hidden border-1 border-black">
          <i
            @click="removePayment(p)"
            class="bg-red-500 text-white rounded h-4 w-4 inline-flex justify-center items-center cursor-pointer fas fa-times"
          ></i>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import useApi from '@/hooks/useApi'
import PAYMENT_METHODS from '@/constants/PAYMENT_METHODS'

export default {
  props: {
    payments: Array,
  },
  emits: ['removed'],
  setup(_, { emit }) {
    const api = useApi()
    const removePayment = payment => {
      api.invoices.removePayment({ id: payment.id }).then(() => {
        emit('removed', payment)
      })
    }

    const isoDatePart = date =>
      String(date || '')
        .split('T')[0]
        .split('-')
        .reverse()
        .join('/')

    return { removePayment, isoDatePart, PAYMENT_METHODS }
  },
}
</script>

<style scoped lang="scss">
table,
tr,
td {
  border: 1px solid #ddd !important;
  padding: 2px 5px !important;
}
thead td {
  padding: 0px 5px !important;
  font-weight: bold;
}
</style>
